import { render, staticRenderFns } from "./compAttribute.vue?vue&type=template&id=f5266628&scoped=true"
import script from "./compAttribute.vue?vue&type=script&lang=js"
export * from "./compAttribute.vue?vue&type=script&lang=js"
import style0 from "./compAttribute.vue?vue&type=style&index=0&id=f5266628&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5266628",
  null
  
)

export default component.exports